<template>
  <div id="Schedule">
		<b-container fluid class="scheduleMain">
			<b-row>
        <b-col>
          <h1>2021 Schedule</h1>
          <div class="line"></div>
        </b-col>
      </b-row>
			<div class="scheduleWrapper">
					<div class="schedule-item">
							<div class="calendar">
									<div class="calendar-month">April</div>
									<div class="calendar-row clearfix">
											<span class="calendar-day-head">Sun</span>
											<span class="calendar-day-head">Mon</span>
											<span class="calendar-day-head">Tue</span>
											<span class="calendar-day-head">Wed</span>
											<span class="calendar-day-head">Thu</span>
											<span class="calendar-day-head">Fri</span>
											<span class="calendar-day-head">Sat</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day">
													<div class="day-number"></div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number"></div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number"></div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number"></div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">1</div>
													<p>MIA <span>4:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">2</div>
													<p>MIA <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">3</div>
													<p>MIA <span>6:10 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day">
													<div class="day-number">4</div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">5</div>
													<p>BOS <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">6</div>
													<p>BOS <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">7</div>
													<p>BOS <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">8</div>
													<p></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">9</div>
													<p>NYY <span>3:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">10</div>
													<p>NYY <span>1:10 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day dark-blue">
													<div class="day-number">11</div>
													<p>NYY <span>1:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">12</div>
													<p>TEX <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">13</div>
													<p>TEX <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">14</div>
													<p>TEX <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">15</div>
													<p>TEX <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">16</div>
													<p>NYY <span>7:05 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">17</div>
													<p>NYY <span>1:05 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day">
													<div class="day-number">18</div>
													<p>NYY <span>1:05 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">19</div>
													<p>KC <span>8:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">20</div>
													<p>KC <span>8:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">21</div>
													<p>KC <span>8:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">22</div>
													<p></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">23</div>
													<p>TOR <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">24</div>
													<p>TOR <span>6:10 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day dark-blue">
													<div class="day-number">25</div>
													<p>TOR <span>1:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">26</div>
													<p>OAK <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">27</div>
													<p>OAK <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">28</div>
													<p>OAK <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">29</div>
													<p>OAK <span>1:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">30</div>
													<p>HOU <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number"></div>
													<p></p>
											</span>
											
									</div>
							</div>
					</div>
					<div class="schedule-item">
							<div class="calendar">
									<div class="calendar-month">May</div>
									<div class="calendar-row clearfix">
											<span class="calendar-day-head">Sun</span>
											<span class="calendar-day-head">Mon</span>
											<span class="calendar-day-head">Tue</span>
											<span class="calendar-day-head">Wed</span>
											<span class="calendar-day-head">Thu</span>
											<span class="calendar-day-head">Fri</span>
											<span class="calendar-day-head">Sat</span>
									</div>
									<div class="calendar-row">
											<div class="calendar-day-np"> </div>
											<div class="calendar-day-np"> </div>
											<div class="calendar-day-np"> </div>
											<div class="calendar-day-np"> </div>
											<div class="calendar-day-np"> </div>
											<div class="calendar-day-np"> </div>
											<span class="calendar-day dark-blue">
													<div class="day-number">1</div>
													<p>HOU <span>4:10 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day dark-blue">
													<div class="day-number">2</div>
													<p>HOU <span>1:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">3</div>
													<p>LAA <span>9:38 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">4</div>
													<p>LAA <span>9:38 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">5</div>
													<p>LAA <span>9:38 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">6</div>
													<p>LAA <span>9:38 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">7</div>
													<p>OAK <span>9:40 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">8</div>
													<p>OAK <span>4:07 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day">
													<div class="day-number">9</div>
													<p>OAK <span>4:07 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">10</div>
													<p></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">11</div>
													<p>NYY <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">12</div>
													<p>NYY <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">13</div>
													<p>NYY <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">14</div>
													<p>NYM <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">15</div>
													<p>NYM <span>1:10 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day dark-blue">
													<div class="day-number">16</div>
													<p>NYM <span>1:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">17</div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">18</div>
													<p>BAL <span>6:35 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">19</div>
													<p>BAL <span>6:35 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">20</div>
													<p>BAL <span>12:35 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">21</div>
													<p>TOR <span>6:37 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">22</div>
													<p>TOR <span>3:07 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day small">
													<div class="day-number">23</div>
													<p>TOR <span>1:07 pm</span></p>
											</span>
											<span class="calendar-day small">
													<div class="day-number">24</div>
													<p>TOR <span>3:07 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">25</div>
													<p>KC <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">26</div>
													<p>KC <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">27</div>
													<p>KC <span>3:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">28</div>
													<p></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">29</div>
													<p>PHI <span>1:10 pm</span></p>
											</span>
											<span class="calendar-day small abs-left dark-blue">
													<div class="day-number">30</div>
													<p>PHI <span>1:10 pm</span></p>
											</span>
											<span class="calendar-day small abs-left2">
													<div class="day-number">31</div>
													<p>NYY <span>1:05 pm</span></p>
											</span>
									</div>
							</div>
					</div>
					<div class="schedule-item">
							<div class="calendar">
									<div class="calendar-month">June</div>
									<div class="calendar-row clearfix">
											<span class="calendar-day-head">Sun</span>
											<span class="calendar-day-head">Mon</span>
											<span class="calendar-day-head">Tue</span>
											<span class="calendar-day-head">Wed</span>
											<span class="calendar-day-head">Thu</span>
											<span class="calendar-day-head">Fri</span>
											<span class="calendar-day-head">Sat</span>
									</div>
									<div class="calendar-row">
											<div class="calendar-day-np"> </div>
											<span class="calendar-day">
													<div class="day-number"></div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">1</div>
													<p>NYY <span>7:05 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">2</div>
													<p>NYY <span>7:05 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">3</div>
													<p>NYY <span>1:05 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">4</div>
													<p>TEX <span>8:05 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">5</div>
													<p>TEX <span>4:05 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day">
													<div class="day-number">6</div>
													<p>TEX <span>2:35 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">7</div>
													<p></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">8</div>
													<p>WSH <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">9</div>
													<p>WSH <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">10</div>
													<p></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">11</div>
													<p>BAL <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">12</div>
													<p>BAL <span>4:10 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day dark-blue">
													<div class="day-number">13</div>
													<p>BAL <span>1:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">14</div>
													<p>CWS <span>8:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">15</div>
													<p>CWS <span>8:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">16</div>
													<p>CWS <span>2:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">17</div>
													<p>SEA <span>10:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">18</div>
													<p>SEA <span>10:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">19</div>
													<p>SEA <span>10:10 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day">
													<div class="day-number">20</div>
													<p>SEA <span>4:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">21</div>
													<p></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">22</div>
													<p>BOS <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">23</div>
													<p>BOS <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">24</div>
													<p>BOS <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">25</div>
													<p>LAA <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">26</div>
													<p>LAA <span>4:10 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day dark-blue">
													<div class="day-number">27</div>
													<p>LAA <span>1:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">28</div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">29</div>
													<p>WSH <span>7:05 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">30</div>
													<p>WSH <span>4:05 pm</span></p>
											</span>
											<div class="calendar-day-np"> </div>
											<div class="calendar-day-np"> </div>
											<div class="calendar-day-np"> </div>
									</div>
							</div>
					</div>
					<div class="schedule-item">
							<div class="calendar">
									<div class="calendar-month">July</div>
									<div class="calendar-row clearfix">
											<span class="calendar-day-head">Sun</span>
											<span class="calendar-day-head">Mon</span>
											<span class="calendar-day-head">Tue</span>
											<span class="calendar-day-head">Wed</span>
											<span class="calendar-day-head">Thu</span>
											<span class="calendar-day-head">Fri</span>
											<span class="calendar-day-head">Sat</span>
									</div>
									<div class="calendar-row">
											<div class="calendar-day-np"> </div>
											<div class="calendar-day-np"> </div>
											<div class="calendar-day-np"> </div>
											<div class="calendar-day-np"> </div>
											<span class="calendar-day">
													<div class="day-number">1</div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">2</div>
													<p>TOR <span>7:07 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">3</div>
													<p>TOR <span>3:07 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day">
													<div class="day-number">4</div>
													<p>TOR <span>1:07 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">5</div>
													<p>CLE <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">6</div>
													<p>CLE <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">7</div>
													<p>CLE <span>12:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">8</div>
													<p></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">9</div>
													<p>TOR <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">10</div>
													<p>TOR <span>1:10 pm</span></p>
											</span>
									</div>
									<div class="allstarText">
										<p>All-Star Break</p>
										<span>Atlanta, GA</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day dark-blue">
													<div class="day-number">11</div>
													<p>TOR <span>1:10 pm</span></p>
											</span>
											
											<span class="calendar-day">
													<div class="day-number">12</div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">13</div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">14</div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">15</div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">16</div>
													<p>ATL <span>7:20 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">17</div>
													<p>ATL <span>7:20 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day">
													<div class="day-number">18</div>
													<p>ATL <span>1:20 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">19</div>
													<p>BAL <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">20</div>
													<p>BAL <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">21</div>
													<p>BAL <span>12:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">22</div>
													<p>CLE <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">23</div>
													<p>CLE <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">24</div>
													<p>CLE <span>1:10 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day">
													<div class="day-number">25</div>
													<p>CLE <span>1:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">26</div>
													<p></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">27</div>
													<p>NYY <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">28</div>
													<p>NYY <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">29</div>
													<p>NYY <span>1:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">30</div>
													<p>BOS <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">31</div>
													<p>BOS <span>6:10 pm</span></p>
											</span>
									</div>
							</div>
					</div>
					<div class="schedule-item">
							<div class="calendar">
									<div class="calendar-month">August</div>
									<div class="calendar-row clearfix">
											<span class="calendar-day-head">Sun</span>
											<span class="calendar-day-head">Mon</span>
											<span class="calendar-day-head">Tue</span>
											<span class="calendar-day-head">Wed</span>
											<span class="calendar-day-head">Thu</span>
											<span class="calendar-day-head">Fri</span>
											<span class="calendar-day-head">Sat</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day dark-blue">
													<div class="day-number">1</div>
													<p>BOS <span>1:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
												<div class="day-number">2</div>
												<p>SEA <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
												<div class="day-number">3</div>
												<p>SEA <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
												<div class="day-number">4</div>
												<p>SEA <span>1:10 pm</span></p>
											</span>
											<span class="calendar-day">
												<div class="day-number">5</div>
												<p></p>
											</span>
											<span class="calendar-day">
												<div class="day-number">6</div>
												<p>BAL <span>7:05 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">7</div>
													<p>BAL <span>7:05 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day">
													<div class="day-number">8</div>
													<p>BAL <span>1:05 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">9</div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">10</div>
													<p>BOS <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">11</div>
													<p>BOS <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">12</div>
													<p>BOS <span>4:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">13</div>
													<p>MIN <span>8:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">14</div>
													<p>MIN <span>7:10 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day">
													<div class="day-number">15</div>
													<p>MIN <span>2:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">16</div>
													<p>BAL <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">17</div>
													<p>BAL <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">18</div>
													<p>BAL <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">19</div>
													<p>BAL <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">20</div>
													<p>CWS <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">21</div>
													<p>CWS <span>1:10 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day dark-blue">
													<div class="day-number">22</div>
													<p>CWS <span>1:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">23</div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">24</div>
													<p>PHI <span>7:05 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">25</div>
													<p>PHI <span>7:05 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">26</div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">27</div>
													<p>BAL <span>7:05 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">28</div>
													<p>BAL <span>7:05 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day">
													<div class="day-number">29</div>
													<p>BAL <span>1:05 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">30</div>
													<p>BOS <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">31</div>
													<p>BOS <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number"></div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number"></div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number"></div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number"></div>
													<p></p>
											</span>

									</div>
							</div>
					</div>
					<div class="schedule-item">
							<div class="calendar">
									<div class="calendar-month">September/October</div>
									<div class="calendar-row clearfix">
											<span class="calendar-day-head">Sun</span>
											<span class="calendar-day-head">Mon</span>
											<span class="calendar-day-head">Tue</span>
											<span class="calendar-day-head">Wed</span>
											<span class="calendar-day-head">Thu</span>
											<span class="calendar-day-head">Fri</span>
											<span class="calendar-day-head">Sat</span>
									</div>
									<div class="calendar-row">
											<div class="calendar-day-np"> </div>
											<div class="calendar-day-np"> </div>
											<div class="calendar-day-np"> </div>
											<span class="calendar-day dark-blue">
													<div class="day-number">1</div>
													<p>BOS <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">2</div>
													<p>BOS <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">3</div>
													<p>MIN <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">4</div>
													<p>MIN <span>4:05 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day dark-blue">
													<div class="day-number">5</div>
													<p>MIN <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">6</div>
													<p>BOS <span>1:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">7</div>
													<p>BOS <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">8</div>
													<p>BOS <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">9</div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">10</div>
													<p>DET <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">11</div>
													<p>DET <span>6:10 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day">
													<div class="day-number">12</div>
													<p>DET <span>1:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">13</div>
													<p>TOR <span>7:07 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">14</div>
													<p>TOR <span>7:07 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">15</div>
													<p>TOR <span>3:07 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">16</div>
													<p>DET <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">17</div>
													<p>DET <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">18</div>
													<p>DET <span>4:10 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day dark-blue">
													<div class="day-number">19</div>
													<p>DET <span>1:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">20</div>
													<p>TOR <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">21</div>
													<p>TOR <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">22</div>
													<p>TOR <span>3:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">23</div>
													<p></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">24</div>
													<p>MIA <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day dark-blue">
													<div class="day-number">25</div>
													<p>MIA <span>6:10 pm</span></p>
											</span>
									</div>
									<div class="calendar-row">
											<span class="calendar-day small dark-blue">
													<div class="day-number">26</div>
													<p>MIA <span>1:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">27</div>
													<p></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">28</div>
													<p>HOU <span>8:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">29</div>
													<p>HOU <span>8:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">30</div>
													<p>HOU <span>7:10 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">1</div>
													<p>NYY <span>7:05 pm</span></p>
											</span>
											<span class="calendar-day">
													<div class="day-number">2</div>
													<p>NYY <span>1:05 pm</span></p>
											</span>
											<span class="calendar-day small abs-left">
													<div class="day-number">3</div>
													<p>NYY <span>3:05 pm</span></p>
											</span>
									</div>
							</div>
					</div>
			</div>
		
			<div class="legend">
				<div class="home"></div>
				<strong>Home</strong>
				<div class="away"></div>
				<strong>Away</strong>
				<span>(Schedule subject to change)</span>
			</div>
		</b-container>
  </div>
</template>

<script>
export default {
	name: "Schedule"
}
</script>

<style lang="scss" scoped>
	#Schedule {
		padding: 50px 0;
		.scheduleMain {
			padding: 0 7%;
			h1 {
        font-family: 'UniversLTStd-UltraCn';
        color: $dark-blue;
        font-size: 50px;
        text-transform: uppercase;
      }
      .line{
        background-color: $yellow;
        width: 190px;
        height: 3px;
        margin: 10px 0;
      }
			.scheduleWrapper{
				display: flex;
				flex-wrap: wrap;
				min-width: 100%;
				width: calc(100% + 20px);
				justify-content: center;
				margin-left: -10px;
				margin-top: 30px;
				.calendar {
					width: 100%;
					height: auto;
					overflow: hidden;
					background: $light-blue;
					color: white;
					border-left: 1px solid $light-blue;
					border-right: 1px solid $light-blue;
					border-bottom: 1px solid $light-blue;
					.allstarText {
						position: absolute;
						width: 200px;
						z-index: 2;
						color: $dark-blue;
						text-align: center;
						margin: 18px 0 0 5%;
						font-family: 'UniversLTStd-Bold';
						font-size: 14px;
						line-height: 14px;
					}
				}
				.calendar .calendar-month {
					text-align: left;
					padding: 5px 5px 5px 10px;
					font-size: 25px;
					text-transform: uppercase;
					font-family: 'UniversLTStd-Bold';
				}
				.calendar .calendar-day-head {
					width: calc(100% / 7);
					display: block;
					float: left;
					text-align: center;
					font-size: 12px;
					text-transform: uppercase;
					font-family: 'UniversLTStd-Bold';
				}
				.calendar .calendar-day-np,
				.calendar .calendar-day {
					position: relative;
					width: calc(100% / 7);
					display: block;
					float: left;
					height: 50px;
					background: white;
					color: #000000;
					border: 1px solid #79BDE7;
					-webkit-transition: all 1s ease;
					-moz-transition: all 1s ease;
					-ms-transition: all 1s ease;
					transition: all 1s ease;
					&.dark-blue {
						background: $dark-blue;
						color: #fff;
						p {
							color: #fff;
							span {
								color: #fff;
							}
						}
					}
				}
				.calendar .calendar-row {
					position: relative;
					overflow: hidden;
					
				}
				.calendar .calendar-day.small {
					height: 24px;
					&.abs-left {
						position: absolute;
						left: 0;
						top: 25px;
					}
					&.abs-left2 {
						position: absolute;
						top: 25px;
						left: calc(100% / 7);
						width: calc(100% / 7);
					}
					&.abs-left3{
						position: absolute;
						top: 25px;
						left: calc(100% / 7);
						width: calc(100% / 7);
						margin-left: calc(100% / 7);
					}
					&.abs-left4{
						position: absolute;
						top: 25px;
						left: calc(100% / 7);
						width: calc(100% / 7);
						margin-left: calc((100% / 7) + 14.2857143%);
					}
					&.abs-left5{
						position: absolute;
						top: 25px;
						left: calc(100% / 7);
						width: calc(100% / 7);
						margin-left: calc((100% / 7) + 28.5714286%);
					}
					p {
						padding: 5px 0;
						font-size: 12px;
						line-height: 12px;
						margin: 0;
						margin-left: 5px;
						span {
							display: block;
							margin-top: -4px;
							font-size: 8px;
						}
					}
				}
				.calendar .calendar-day .day-number {
					position: absolute;
					font-size: 8px;
					top: 2px;
					left: 2px;
					font-family: 'UniversLTStd-Bold';
				}
				.calendar .calendar-day p {
					margin: 0;
					padding: 20px 0;
					font-size: 16px;
					display: block;
					text-align: center;
					line-height: 1;
					color: #00285E;
					font-family: 'UniversLTStd-Bold';
					span {
						display: block;
						font-size: 8px;
						margin-top: 0px;
						color: #00285E;
					}
				}
				.calendar .calendar-day.active {
					background: #002D62;
					.day-number,
					p {
						color: #fff;
						span {
							color: #fff;
						}
					}
				}
				.calendar .calendar-day.active .day-number,
				.calendar .calendar-day.active p {
					color: white
				}
				.schedule-item {
					width: calc(33.33% - 21px);
					margin: 10px;
					@media only screen and (max-width: $lg) {
						width: calc(50% - 21px);
					}
					@media only screen and (max-width: $md) {
						width: calc(100% - 21px);
					}
				}
			}
			.legend {
				margin-top: 20px;
				display: flex;
				flex-direction: row;
				@media only screen and (max-width: $sm) {
					flex-direction: column;
				}
				.home {
					height: 30px;
					width: 30px;
					background-color: #002D62;
					border: 1px solid #FFF;
					margin-right: 10px;
					@media only screen and (max-width: $sm) {
						height: 20px;
						width: 20px;
					}
				}
				.away {
					height: 30px;
					width: 30px;
					margin-right: 10px;
					background-color: #FFF;
					border: 1px solid $dark-blue;
					@media only screen and (max-width: $sm) {
						height: 20px;
						width: 20px;
					}
				}
				strong {
					font-size: 16px;
					color: $dark-blue;
					letter-spacing: 0;
					line-height: 24px;
					margin-right: 20px;
					font-weight: 800;
				}
				span {
					font-size: 16px;
					color: $dark-blue;
					letter-spacing: 0;
					line-height: 24px;
				}
			}
		}
	}
</style>